// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "./Base"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("./Base"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.Base);
    global.Display = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _Base) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Display = Display;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  var VARIANT_SIZE_MAP = {
    sm: '5xl',
    base: '6xl'
  };
  var VARIANT_LEADING_MAP = {
    sm: 'tight',
    base: 'tight'
  };
  function Display(_ref) {
    var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'h1' : _ref$tag,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'base' : _ref$variant,
      size = _ref.size;
    return /*#__PURE__*/_react["default"].createElement(_Base.Base, {
      className: className,
      size: VARIANT_SIZE_MAP[size !== null && size !== void 0 ? size : variant],
      variant: "display",
      tag: tag,
      leading: VARIANT_LEADING_MAP[size !== null && size !== void 0 ? size : variant],
      weight: 'medium'
    }, children);
  }
});
